import React from "react";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import type { Task } from "@services/vesselCall/types";
import { canUserReject } from "../utils";

interface RejectVesselCallProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const RejectVesselCall: React.FC<RejectVesselCallProps> = ({ vesselCallFlowData, openDrawer }) => {
  if (!vesselCallFlowData || !vesselCallFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserReject(
    vesselCallFlowData.task.status,
    vesselCallFlowData.task.claimOwnerName,
    vesselCallFlowData.status,
  );
  const handleRejectClick = () => {
    openDrawer("rejectDrawer");
  };

  return (
    <RejectButton
      langBase={LANG_BASE}
      permission="canRejectVesselCall"
      isActionAvailable={isActionAvailable}
      onReject={handleRejectClick}
    />
  );
};
export default RejectVesselCall;
